import PrimeVue from 'primevue/config';
import Aura from './presets/aura';

export default {
    install(app) {
        app.use(PrimeVue, {
            unstyled: true,
            darkModeSelector: '.dark-mode',
            pt: Aura,
        });
    },
};
